<template>
  <div class="ui-no-data">
    <i class="mdi mdi-folder-search-outline"></i>
    <div class="ui-no-data-text"><slot /></div>
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss">
.ui-no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  > i {
    font-size: 100px;
    color: var(--v-theme-light-color);
  }

  .ui-no-data-text {
    font-size: 14px;
    color: var(--v-gray);
    font-weight: 500;
  }
}
</style>
